import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalDiscardGuardService {
  readonly isOpen = signal(false);
  readonly title = signal('Discard changes?');
  readonly message = signal('You have unsaved changes in this modal. Close anyway?');
  readonly confirmText = signal('Discard');
  readonly cancelText = signal('Keep editing');

  private pendingResolver: ((confirmed: boolean) => void) | null = null;

  requestDiscardConfirmation(): Promise<boolean> {
    if (this.pendingResolver) {
      this.pendingResolver(false);
      this.pendingResolver = null;
    }

    this.isOpen.set(true);
    return new Promise<boolean>(resolve => {
      this.pendingResolver = resolve;
    });
  }

  confirmDiscard(): void {
    this.resolveAndClose(true);
  }

  cancelDiscard(): void {
    this.resolveAndClose(false);
  }

  private resolveAndClose(confirmed: boolean): void {
    const resolver = this.pendingResolver;
    this.pendingResolver = null;
    this.isOpen.set(false);
    resolver?.(confirmed);
  }
}
